import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { GlobalService } from '.';

@Injectable({
    providedIn: 'root'
})

export class AuthGuardService {

    _awaysAllowUrls = new Array<string>();
    _authUrls = new Array<string>();

    constructor(
        private authService: AuthService,
        private router: Router,
        private gs: GlobalService
    ) {
        this.buildAwaysAllowUrls();
        this.buildAuthUrls();
    }

    private buildAwaysAllowUrls() {

        //this._awaysAllowUrls.push('/user-change-password');

        this._awaysAllowUrls.push('/inicio');

    }

    private buildAuthUrls() {

        this._authUrls.push('/login');

        this._authUrls.push('/email-senha');

        this._authUrls.push('/redefinir-senha');
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.isAuthenticated();
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        let isAuthenticated = this.isAuthenticated();

        if (!isAuthenticated) {
            if (this.isAuthUserUrl(state.url))
                return true;

            this.gs.signOut();
            return false;
        }

        // Token de escopo "reativacao" não tem acesso ao bloco privado;
        // redireciona para a tela de reativação (única rota que aceita esse escopo).
        if (this.authService.isReativacaoScope()) {
            return this.router.parseUrl('/reativacao');
        }

        if (!this.hasToRenewPassword()) {
            if (this.isAwaysAllowUrl(state.url))
                return true;

            if ((!this.gs.verifyInterfacePermission(state.url) && state.url !== "/inicio") || this.isAuthUserUrl(state.url))
                this.router.navigateByUrl('/inicio');
        } else if (state.url !== "/redefinir-senha") {
            this.router.navigateByUrl('/redefinir-senha');
        }

        return isAuthenticated;
    }

    private isAwaysAllowUrl(url: string): boolean {
        return this._awaysAllowUrls.some(x => x === url);
    }

    private isAuthUserUrl(url: string): boolean {
        return this._authUrls.some(x => x === url);
    }

    private isAuthenticated(): boolean {
        return this.authService.isTokenValid();
    }

    private hasToRenewPassword(): boolean {
        return !!this.authService.getUserInToken() && this.authService.getUserInToken()?.renewPasswordFlag == "True";
    }
}